import { gql } from "@apollo/client";

export const USER_POOL_GET_GIFT_CARD_PURCHASE_STATUS = gql`
  query UserPoolGetGiftCardPurchaseStatus(
    $networkName: String!
    $requestId: String!
    $paymentAttemptId: String
  ) {
    purchaseStatus: getGiftCardPurchaseStatus(
      networkName: $networkName
      requestId: $requestId
      paymentAttemptId: $paymentAttemptId
    ) {
      requestId
      paymentAttemptId
      publicStatus
      recommendedAction
      eagerGiftCard {
        id
        cardId
        offerId
        barCodeImageUrl
        barCodeType
        cardNumber
        cardPin
        createdAt
        reloadHistory {
          amount {
            fiat {
              value
            }
          }
          totalSaleAmount
          btcVoucherDetails {
            btcVoucherUserAmount
          }
          giftDetails {
            name
            emailAddress
            message
          }
        }
        offer {
          id
          offerId
          brandName
          networkName
          barCodeType
          presetAmounts
          instruction {
            locale
            text
          }
          productDescription {
            locale
            text
          }
          termsAndConditions {
            inAppCard {
              locale
              text
            }
          }
          reloadSettings {
            isReloadable
          }
          commissionSettings {
            grossCommissionAmount
            memberRewardAmount
            isPercentage
          }
          styleSettings {
            includeImageBorder
            isCustomImageUpload
          }
          images {
            imageUrl
          }
        }
      }
    }
  }
`;
